var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAdd24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 4c.5523 0 1 .4477 1 1v6h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6v6c0 .5523-.4477 1-1 1s-1-.4477-1-1l-.001-6H5c-.5523 0-1-.4477-1-1s.4477-1 1-1h5.999L11 5c0-.5523.4477-1 1-1Z"
})));
export { SvgAdd24 as ReactComponent };